import React, { useCallback, useEffect, useState } from 'react';
import { Grid, TextField } from '@material-ui/core';

import { debounce, LabelName, Required, validateCustomFields } from '../../../../../utils';

export function NumberNormalView({
  data,
  setData,
  setError,
  ind,
  isRequired,
  globalStateData,
  setCustomFieldsValidation,
}) {
  const [value, setValue] = useState(
    globalStateData?.customFormData?.[ind]?.fieldValue !== undefined
      ? String(globalStateData.customFormData[ind].fieldValue)
      : '',
  );
  const isDisabled =
    globalStateData?.customFormData?.[ind]?.isEditable !== undefined
      ? !globalStateData?.customFormData?.[ind]?.isEditable
      : false;

  const [error1, setError1] = useState('');

  useEffect(() => {
    setError(null);
    setData(Number(value), ind);
  }, [value]);

  const debouncedValidation = useCallback(
    debounce((fieldData, setError2) => {
      const resp = validateCustomFields(fieldData);
      if (!resp.isValid) {
        setError2(resp.errorMessage);
        setCustomFieldsValidation((prev) => ({
          ...prev,
          [data?.fieldName]: false,
        }));
      } else {
        setError2('');
        setCustomFieldsValidation((prev) => ({
          ...prev,
          [data?.fieldName]: true,
        }));
      }
      if (fieldData.value === '') setError2('');
    }, 350),
    [],
  );

  const handleInputChange = (e) => {
    setValue(e.target.value);
    setError1('');
    const { fieldType, numberValidation, required } = data;
    const fieldData = {
      fieldType,
      numberValidation,
      required,
      value: e.target.value,
    };

    debouncedValidation(fieldData, setError1);
  };

  return (
    <Grid container style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Grid item>
        <LabelName>
          {data?.fieldName}
          {isRequired && <Required> *</Required>}
        </LabelName>
      </Grid>
      <Grid item>
        <TextField
          type="number"
          required={isRequired}
          placeholder="Enter Number"
          value={value}
          inputProps={{ 'data-testid': 'testType', maxLength: 45 }}
          onChange={handleInputChange}
          style={{ width: '100%' }}
          disabled={isDisabled}
          variant="outlined"
        />
      </Grid>
      {error1 && <span style={{ color: 'red', fontSize: '0.9rem' }}>{error1}</span>}
    </Grid>
  );
}

export default NumberNormalView;
